module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-impressum-circle-29c91f056a60722de57311e37be97dbb.svg";